// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Types
import { GetStateSuccessBuilderHandlersType } from 'containers/get-state/handlers/types/get-state.handlers.type';

const checkoutHasErrorOrIsNotLegit = (
  state: GetStateSuccessBuilderHandlersType['state']
): boolean =>
  [AppStatesEnumeration.CHECKOUT_COMPLETED, AppStatesEnumeration.EXPIRED].includes(state);

const onboardingHasBeenDeclinedByRisk = (
  state: GetStateSuccessBuilderHandlersType['state']
): boolean => [AppStatesEnumeration.DECLINED, AppStatesEnumeration.CANCELLED].includes(state);

const stateIsCheckoutLoading = (state: GetStateSuccessBuilderHandlersType['state']): boolean =>
  state === AppStatesEnumeration.CHECKOUT_LOADING;

export { checkoutHasErrorOrIsNotLegit, onboardingHasBeenDeclinedByRisk, stateIsCheckoutLoading };
